import {
    SET_ATTENTION_TEXT,
    SET_ERROR_TEXT,
    SET_WARNING_TEXT,
    SET_EXTERNAL_LINK_TEXT,
    SET_ERROR_LOGIN_USER_TEXT,
    SET_COMMON_TEXTS,
} from './constants'

export function setAttentionText(text) {
    return {
        type: SET_ATTENTION_TEXT,
        payload: text,
    }
}

export function setErrorText(text) {
    return {
        type: SET_ERROR_TEXT,
        payload: text,
    }
}

export function setWarningText(text) {
    return {
        type: SET_WARNING_TEXT,
        payload: text,
    }
}

export function setExternalLinkText(text) {
    return {
        type: SET_EXTERNAL_LINK_TEXT,
        payload: text,
    }
}

export function setErrorLoginUserText(text) {
    return {
        type: SET_ERROR_LOGIN_USER_TEXT,
        payload: text,
    }
}

export function setCommonTexts(texts) {
    return {
        type: SET_COMMON_TEXTS,
        payload: texts,
    }
}



// WEBPACK FOOTER //
// ./src/features/CommonTexts/data/actions.js